
import { 
  Home, Utensils, Car, Shirt, Heart, Brush, BookOpen, Gamepad2, 
  Plane, PawPrint, Gift, TrendingUp, RotateCcw, Receipt, Calculator, 
  Wrench, Shield, Wallet, Briefcase, ShoppingBag, Building, PiggyBank,
  // Ícones adicionais para personalização
  Coffee, Music, Dumbbell, Smartphone, Laptop, Headphones, Camera,
  ShoppingCart, Pizza, Fuel, Bus, Train, Bike,
  Baby, GraduationCap, Stethoscope, Pill, Scissors, Paintbrush,
  Book, Film, Trophy, Map, Compass, Mountain,
  Sun, Moon, Star, Cloud, Umbrella, Flower, Trees, Leaf,
  DollarSign, CreditCard, Banknote, Coins, Vault, ChartBar,
  Settings, Hammer, Key, Lock, Bell,
  Phone, Mail, MessageCircle, Video, Calendar, Clock, Timer,
  User, Users, UserPlus, Crown, Award, Medal, Target
} from 'lucide-react';

export interface CategoryIconOption {
  name: string;
  icon: any;
  category: string;
}

export const CATEGORY_ICONS: CategoryIconOption[] = [
  // Casa e Moradia
  { name: 'Casa', icon: Home, category: 'casa' },
  { name: 'Construção', icon: Hammer, category: 'casa' },
  { name: 'Chave', icon: Key, category: 'casa' },
  { name: 'Segurança', icon: Lock, category: 'casa' },
  
  // Alimentação
  { name: 'Restaurante', icon: Utensils, category: 'alimentacao' },
  { name: 'Café', icon: Coffee, category: 'alimentacao' },
  { name: 'Pizza', icon: Pizza, category: 'alimentacao' },
  { name: 'Carrinho de Compras', icon: ShoppingCart, category: 'alimentacao' },
  
  // Transporte
  { name: 'Carro', icon: Car, category: 'transporte' },
  { name: 'Combustível', icon: Fuel, category: 'transporte' },
  { name: 'Ônibus', icon: Bus, category: 'transporte' },
  { name: 'Trem', icon: Train, category: 'transporte' },
  { name: 'Bicicleta', icon: Bike, category: 'transporte' },
  
  // Vestuário
  { name: 'Roupas', icon: Shirt, category: 'vestuario' },
  { name: 'Compras', icon: ShoppingBag, category: 'vestuario' },
  
  // Saúde
  { name: 'Coração', icon: Heart, category: 'saude' },
  { name: 'Estetoscópio', icon: Stethoscope, category: 'saude' },
  { name: 'Remédio', icon: Pill, category: 'saude' },
  { name: 'Exercício', icon: Dumbbell, category: 'saude' },
  
  // Cuidados Pessoais
  { name: 'Pincel', icon: Brush, category: 'cuidados' },
  { name: 'Tesoura', icon: Scissors, category: 'cuidados' },
  { name: 'Pincel de Arte', icon: Paintbrush, category: 'cuidados' },
  
  // Educação
  { name: 'Livro', icon: BookOpen, category: 'educacao' },
  { name: 'Graduação', icon: GraduationCap, category: 'educacao' },
  { name: 'Livro Fechado', icon: Book, category: 'educacao' },
  
  // Lazer
  { name: 'Jogo', icon: Gamepad2, category: 'lazer' },
  { name: 'Música', icon: Music, category: 'lazer' },
  { name: 'Filme', icon: Film, category: 'lazer' },
  { name: 'Troféu', icon: Trophy, category: 'lazer' },
  { name: 'Câmera', icon: Camera, category: 'lazer' },
  
  // Viagens
  { name: 'Avião', icon: Plane, category: 'viagens' },
  { name: 'Mapa', icon: Map, category: 'viagens' },
  { name: 'Bússola', icon: Compass, category: 'viagens' },
  { name: 'Montanha', icon: Mountain, category: 'viagens' },
  
  // Pets
  { name: 'Pata', icon: PawPrint, category: 'pets' },
  
  // Presentes
  { name: 'Presente', icon: Gift, category: 'presentes' },
  
  // Tecnologia
  { name: 'Smartphone', icon: Smartphone, category: 'tecnologia' },
  { name: 'Laptop', icon: Laptop, category: 'tecnologia' },
  { name: 'Fones', icon: Headphones, category: 'tecnologia' },
  
  // Financeiro
  { name: 'Dinheiro', icon: DollarSign, category: 'financeiro' },
  { name: 'Carteira', icon: Wallet, category: 'financeiro' },
  { name: 'Cartão', icon: CreditCard, category: 'financeiro' },
  { name: 'Notas', icon: Banknote, category: 'financeiro' },
  { name: 'Moedas', icon: Coins, category: 'financeiro' },
  { name: 'Cofre', icon: Vault, category: 'financeiro' },
  { name: 'Gráfico', icon: ChartBar, category: 'financeiro' },
  { name: 'Crescimento', icon: TrendingUp, category: 'financeiro' },
  { name: 'Porquinho', icon: PiggyBank, category: 'financeiro' },
  
  // Trabalho
  { name: 'Maleta', icon: Briefcase, category: 'trabalho' },
  { name: 'Prédio', icon: Building, category: 'trabalho' },
  
  // Outros
  { name: 'Recibo', icon: Receipt, category: 'outros' },
  { name: 'Calculadora', icon: Calculator, category: 'outros' },
  { name: 'Ferramenta', icon: Wrench, category: 'outros' },
  { name: 'Escudo', icon: Shield, category: 'outros' },
  { name: 'Configurações', icon: Settings, category: 'outros' },
  { name: 'Sino', icon: Bell, category: 'outros' },
  { name: 'Telefone', icon: Phone, category: 'outros' },
  { name: 'Email', icon: Mail, category: 'outros' },
  { name: 'Mensagem', icon: MessageCircle, category: 'outros' },
  { name: 'Vídeo', icon: Video, category: 'outros' },
  { name: 'Calendário', icon: Calendar, category: 'outros' },
  { name: 'Relógio', icon: Clock, category: 'outros' },
  { name: 'Timer', icon: Timer, category: 'outros' },
  { name: 'Usuário', icon: User, category: 'outros' },
  { name: 'Usuários', icon: Users, category: 'outros' },
  { name: 'Coroa', icon: Crown, category: 'outros' },
  { name: 'Prêmio', icon: Award, category: 'outros' },
  { name: 'Medalha', icon: Medal, category: 'outros' },
  { name: 'Alvo', icon: Target, category: 'outros' },
  { name: 'Árvore', icon: Trees, category: 'outros' },
  { name: 'Flor', icon: Flower, category: 'outros' },
  { name: 'Folha', icon: Leaf, category: 'outros' },
  { name: 'Sol', icon: Sun, category: 'outros' },
  { name: 'Lua', icon: Moon, category: 'outros' },
  { name: 'Estrela', icon: Star, category: 'outros' },
  { name: 'Nuvem', icon: Cloud, category: 'outros' },
  { name: 'Guarda-chuva', icon: Umbrella, category: 'outros' }
];

// Mapeamento de ícones padrão para categorias existentes
export const DEFAULT_CATEGORY_ICONS: Record<string, any> = {
  // Categorias de Despesa
  'Moradia': Home,
  'Alimentação': Utensils,
  'Transporte': Car,
  'Vestuário': Shirt,
  'Saúde': Heart,
  'Cuidados Pessoais': Brush,
  'Educação': BookOpen,
  'Lazer': Gamepad2,
  'Viagens': Plane,
  'Pets': PawPrint,
  'Presentes': Gift,
  'Investimentos': TrendingUp,
  'Assinaturas': RotateCcw,
  'Contas': Receipt,
  'Impostos': Calculator,
  'Manutenção e Reparos': Wrench,
  'Seguros': Shield,
  'Outros': Settings,
  
  // Categorias de Receita
  'Salário': Wallet,
  'Serviços': Briefcase,
  'Vendas': ShoppingBag,
  'Aluguel': Building,
  'Dividendos': TrendingUp,
  'Presentes Recebidos': Gift,
  'Investimentos Receitas': PiggyBank,
  'Outros Receita': Settings,
  
  // Categorias Empresariais - Despesa
  'Fornecedores': ShoppingCart,
  'Salários e Encargos': Wallet,
  'Marketing e Publicidade': TrendingUp,
  'Aluguel e Instalações': Building,
  'Tecnologia e Software': Laptop,
  'Impostos e Taxas': Calculator,
  'Consultoria': Briefcase,
  'Materiais de Escritório': Settings,
  'Viagens Corporativas': Plane,
  'Treinamento e Capacitação': BookOpen,
  'Seguros Empresariais': Shield,
  'Outros Empresarial': Settings,
  
  // Categorias Empresariais - Receita
  'Vendas de Produtos': ShoppingBag,
  'Prestação de Serviços': Briefcase,
  'Receitas Financeiras': TrendingUp,
  'Licenciamento': Award,
  'Comissões': DollarSign,
  'Royalties': Crown,
  'Subsídios': Gift
};

export const getIconByName = (iconName: string) => {
  const iconOption = CATEGORY_ICONS.find(icon => icon.name === iconName);
  return iconOption?.icon || Settings;
};

export const getCategoryIconCategories = () => {
  const categories = [...new Set(CATEGORY_ICONS.map(icon => icon.category))];
  return categories;
};

export const getIconsByCategory = (category: string) => {
  return CATEGORY_ICONS.filter(icon => icon.category === category);
};
